import React from "react";
import Transaction from "./Transaction";
import { Grid} from "@mui/material";
import dayjs from 'dayjs';
import HistYearPanel from "./HistYearPanel"
import MenuDrawer from "./MenuDrawer";
import Favorites from "./Favorites";
import { getTransactions, saveTransactions } from "./connect_data";
import CloudDialog from "./CloudDialog";
import { useMemo } from "react";
import WeddingDialog from "./WeddingDialog";
import ScribbleCardDialog from "./ScribbleCardDialog";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PlotsPanel from "./PlotsPanel";

import CanvasComponent from "./CanvasComponent";

export default class HistPanel extends React.Component {
    state  = {
        temp:0,
        count:0,
        transactions: [
            // new Transaction(dayjs(new Date("Jan 10, 2023")), "Kroger", -100),
            // new Transaction(dayjs(new Date("Jan 12, 2023")), "Car", -200),
            // new Transaction(dayjs(new Date("Jan 16, 2023")), "Salary", 350)
        ],
        history:[],
        favorites : [
            {name:"Kroger", "sum":100.10, used:false},
            {name:"Car", "sum":300.10, used:false},
            {name:"Utilities", "sum":123.20, used:true}
        ],
        collapseOpened:true,
        dialogOpened:false,
        dogDialogOpened:false,
        scribbleCardDialog: false,
        tabValue: "history"
    };
    temp = 0



    constructor(props) {
        super(props)
        this.deleteTransaction = this.deleteTransaction.bind(this);
        this.copyTransaction = this.copyTransaction.bind(this);
        this.update = this.update.bind(this)
        this.addItem = this.addItem.bind(this)
        this.loadFile = this.loadFile.bind(this)
        this.fileLoaderListener = this.fileLoaderListener.bind(this)
        this.saveFile = this.saveFile.bind(this)
        this.pushHistory = this.pushHistory.bind(this)
        this.undo = this.undo.bind(this)
        this.favsClicked = this.favsClicked.bind(this)
        this.addAllFavs = this.addAllFavs.bind(this)
        this.refreshAllFavs = this.refreshAllFavs.bind(this)
        this.deleteFav = this.deleteFav.bind(this)
        this.changeFavName = this.changeFavName.bind(this)
        this.changeFavSum = this.changeFavSum.bind(this)
        this.addFav = this.addFav.bind(this)
        this.addTransToFavs = this.addTransToFavs.bind(this)
        //
        this.saveToCloud = this.saveToCloud.bind(this);
        this.setDogDialogOpened = this.setDogDialogOpened.bind(this)
        this.setScribbleCardDialogOpened = this.setScribbleCardDialogOpened.bind(this)
    };

    setDogDialogOpened(val) {
        this.setState({dogDialogOpened:val})
    }

    setScribbleCardDialogOpened(val) {
        this.setState({scribbleCardDialog:val})
    }

    pushHistory() {
        this.state.history.push([...this.state.transactions])
    }

    componentDidMount(){
        window.onbeforeunload = function() {
            return true;
        };
    }
    
    // componentDidUnmount(){
    //     window.onbeforeunload = null;
    // }

    update() {
        console.log("Updating")
        var trs = this.state.transactions
        trs.sort( (a,b) => b.date.toDate().getTime() - a.date.toDate().getTime())
        this.setState({transactions:trs})
        this.forceUpdate()
        // console.log("history=", this.state.history)
    }


    deleteTransaction(index,) {
        console.log("Deleting transaction number ", index);
        this.pushHistory()
        this.state.transactions.splice(index, 1);
        this.update()
    }
   
    copyTransaction(index) {
        console.log("Copying transaction no ", index);
        this.pushHistory()
        var trans = this.state.transactions;
        var newTransaction = trans[index].copy()
        var oldDate = newTransaction.date
        var newDate = oldDate.month( oldDate.month()+1)
        newTransaction.setDate( newDate)
        console.log(newTransaction.date)
        trans.push(newTransaction)
        // this.state.transactions.push(this.state.transactions[index].copy())
        this.update()
    }

    undo() {
        if(this.state.history.length>0) {
            this.state.transactions = [...this.state.history.pop()]
            this.forceUpdate()
        }
    }

    addItem({name="add item", sum=0}) {
        this.pushHistory()
        this.state.transactions.push(new Transaction(dayjs(new Date()), name, sum))
        this.update()
    }


    saveToCloud(name) {
        console.log("Saving to Cloud")
        saveTransactions("New4", this.state.transactions, this.state.favorites)

    }

    saveFile() {
        console.log("Saving to file. temp=", this.temp);
        this.temp = this.temp + 1
        var jsonData = JSON.stringify({transactions:this.state.transactions, 
            favorites:this.state.favorites})
        const a = document.createElement("a")
        const file = new Blob([jsonData], { type: "text/plain" });
        a.href = URL.createObjectURL(file);
        a.download = "./transactions.json";
        a.click();
        URL.revokeObjectURL(a.href);
    }

    readerFunction(reader) {
        console.log("readerFunction")
        var jsonText = reader.result
        var jsonData = JSON.parse(jsonText)
        console.log("jsonData=", jsonData)
        var transactions = jsonData["transactions"].map( t => 
            new Transaction(dayjs(new Date(t.date)), t.comment, t.sum)
        )
        this.state.transactions = transactions
        var favorites
        if(jsonData["favorites"] === undefined) {
            favorites = [{name:"???", sum:0, used:false}]
        } else 
        {
            favorites = jsonData["favorites"]
        }
        this.state.favorites = favorites
        this.update()
    }

    fileLoaderListener(fileInput) {
        console.log("fileLoaderListener: fileInput.files=", fileInput.files)
        if(fileInput.files.length>0) {
            var file = fileInput.files[0]
            console.log("Loading file ", file['name'])
        if (file.name.match(/\.(txt|json)$/)) {
            var reader = new FileReader();
            reader.onload = () => this.readerFunction(reader);
            reader.readAsText(file);
        } else {
            alert("File not supported, .txt or .json files only");
        }
        }
    }


    loadFile() {
        console.log("Loading from file")
        var fileDialog = document.createElement("div");
        fileDialog.innerHTML = '<input type="file">'
        var fileInput = fileDialog.firstChild;
        fileInput.addEventListener('change', () => this.fileLoaderListener(fileInput));
        fileInput.click();
    }

    favsClicked(index) {
        console.log(index, " clicked")
        var fav = this.state.favorites[index]
        fav["used"] = true;
        this.addItem({name:fav.name, sum:fav.sum})
        this.forceUpdate()
    }

    addAllFavs() {
        this.state.favorites.map( (F, index) => this.favsClicked(index))
    }

    refreshAllFavs() {
        var favs=this.state.favorites
        favs.map( (F) => F.used = false)
        this.forceUpdate()
    }

    deleteFav(index) {
        this.state.favorites.splice(index, 1);
        this.forceUpdate();
    }

    changeFavName(index, e) {
        this.state.favorites[index].name = e.target.value
        this.forceUpdate()
    }

    changeFavSum(index, e) {
        this.state.favorites[index].sum = e.target.value
        this.forceUpdate()
    }

    addFav() {
        this.state.favorites.push({name:"???", sum:0, used:false})
        this.forceUpdate()
    }

    addTransToFavs(index) {
        console.log("Adding transaction ", index, " to Favorites")
        this.state.favorites.push({
            name:this.state.transactions[index].comment, 
            sum:this.state.transactions[index].sum, used:false}
            )
        this.forceUpdate()
    }

    render() {
        let years = [...new Set(this.state.transactions.map( a => a.date.year() ))]
        var totalSum = this.state.transactions.map( (t)=>parseFloat(t.sum)).reduce( (a,b) => a+b,0)
        totalSum = Math.ceil(100*totalSum)/100
        var totalLine =
        <Grid container>
            <Grid item xs={1}>[history]={this.state.history.length}</Grid>
            <Grid item xs={4}/>
            <Grid item xs={1}>Total transactions</Grid>
            <Grid item xs={1}>{this.state.transactions.length}</Grid>
            <Grid item xs={2}>Total amount</Grid>
            <Grid item xs={2}>
                <span style={{fontWeight:"bold", fontSize:"150%", border:"2px solid black"}}>
                {totalSum}
            </span></Grid>
        </Grid>

        var mainPanel = <div>
            {
            years.map( (y, index) =>
            <HistYearPanel year = {y} transactions = {this.state.transactions}
            key = {index}
            deleteHandle={this.deleteTransaction} copyHandle = {this.copyTransaction} 
            updateHandle={this.update}
            addTransToFavsHandle={this.addTransToFavs}/>                    
            )
            }
            </div>

        
        var historyTab = 
            <div>
            <h1>Transaction History</h1>
            {totalLine}
            <p/>
            <Grid container>
                <Grid item xs={1}>
                    <MenuDrawer
                    update={this.update}
                    undo={this.undo}
                    loadFile={this.loadFile}
                    saveFile={this.saveFile}
                    addItem={this.addItem}
                    openCloudDialog = {() => this.setState({dialogOpened:true})}
                    saveToCloud={this.saveToCloud}
                    openDogDialog = {() => this.setDogDialogOpened(true)}
                    openScribbleCardDialog = {() => this.setScribbleCardDialogOpened(true)}
                    /></Grid>
                <Grid item xs={7}>
                    {/* <div style={{flex:1, height:"90%", overflow:"scroll"}}> */}
                    <div>
                    {mainPanel}
                    </div>
                    </Grid>
                    {/* <Grid item xs={4} style={{ background: '#f2f6fc' }}> */}
                    <Grid item xs={4}>
                    <Favorites favorites={this.state.favorites}
                                favsClicked={this.favsClicked}
                                addAllFavs={this.addAllFavs}
                                refreshAllFavs = {this.refreshAllFavs}
                                deleteFav = {this.deleteFav}
                                changeFavName = {this.changeFavName}
                                changeFavSum = {this.changeFavSum}
                                addFav = {this.addFav}
                                />
                </Grid>
            </Grid>
            <CloudDialog
            opened = {this.state.dialogOpened}
            handleClose={() => {
                console.log("Closing dialog")
                this.setState({dialogOpened:false})
                this.forceUpdate()
            }}
            handleLoad={(trans, favs) => {
                this.setState({transactions:trans, favorites:favs, dialogOpened:false})
            }}
            handleSave={(userName) => {
                this.setState({dialogOpened:false})
                saveTransactions(userName, this.state.transactions, this.state.favorites)}
            }
            />
            <WeddingDialog open = {this.state.dogDialogOpened} handelOpen={this.setDogDialogOpened}/>
            <ScribbleCardDialog open={this.state.scribbleCardDialog} 
                handelOpen={this.setScribbleCardDialogOpened}/>
        </div>

        // return(
        //     <div>
        //         <h1>CANVAS</h1>
        //         <CanvasComponent/>
        //     </div>
        // )

        return (
            <div>
                <Tabs value = {this.state.tabValue} onChange={(e, tabIndex) => {
                    this.setState({tabValue:tabIndex})
                }}>
                <Tab label="History" value = "history"/>
                <Tab label="Plot and Table" value = "plots"/>
                </Tabs>
            {this.state.tabValue=="history" && historyTab}
            {this.state.tabValue=="plots" && <PlotsPanel transactions={this.state.transactions}/>}
            </div>
        );
    }
}

